export const ROLE_NAME_OWNER = 'Owner';
export const ROLE_NAME_ADMINISTRATOR = 'Administrator';
export const ROLE_NAME_USER = 'User';
